import { useSelector } from "react-redux";

// Components
import AlertMessage from "../../mavin/components/alert-message/AlertMessage";

/**
 * Heatmap Loading Indicator
 */
export default function HeatmapLoadingIndicator() {
  // heatmap data loading
  const poiTypeLayerDataLoading = useSelector(
    (state) => state.geoData.poiTypeLayerDataLoading
  );

  // hide indicator
  if (!poiTypeLayerDataLoading) {
    return null;
  }

  return (
    <div className="heatmap-loading-indicator">
      <AlertMessage
        className="justify-content-center mt-3 p-2 font-weight-bold"
        spinnerClassName="spinner-border-sm"
        textMessage="Generating Heatmap, Please Wait..."
      />
    </div>
  );
}
